import { useState } from "react";
import { getFromLocalStorage } from "../components/helper/authorizationHelper";

export function iterateSessionStorage() {
  const [epUserID, setEpUserID] = useState(null);
  const sessionStorageValues = {};

  for (const [key, value] of Object.entries(localStorage)) {
    if (key === 'upid') {
      const retrievedData = getFromLocalStorage("upid");
      retrievedData
        ?.then((res) => {
          setEpUserID(res);
        })
        .catch((err) => {
          console.log('data', err);
        });

    }
    sessionStorageValues[key] = value;
  }
  const data = { ...sessionStorageValues, upid: epUserID };
  return data;
}
